import { createStore }                                                    from 'vuex';
import { CpqCartProductLineJson }                                         from '@/libs/cpq-builder/cpq-json.interface';
import { getLocalOrDefaultLang, getPaymentTypeOrDefault, StateInterface } from '@/store/util';
import * as _                                                             from 'lodash';
import { PaymentTypeKeys }                                                from '../constants';

const mutations = {
  addProductToCart  : (state: StateInterface, product: CpqCartProductLineJson) => {
    delete (product as any).index;
    product.catalogKey = product.key;
    state.cpq.cart.products.push(product);
    // localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  updateCartProducts: (state: StateInterface, cartProducts: CpqCartProductLineJson[]) => {
    state.cpq.cart.products = cartProducts;
    // localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  updateCartProduct: (state: StateInterface, data: { idx: number, cartProduct: CpqCartProductLineJson }) => {
    delete (data.cartProduct as any).index;
    if (data.idx < state.cpq.cart.products.length) {
      state.cpq.cart.products[data.idx] = data.cartProduct;
      // localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
    }
  },
  duplicateCartProduct: (state: StateInterface, idx: number) => {
    if (idx < state.cpq.cart.products.length) {
      const product = _.cloneDeep(state.cpq.cart.products[idx]);
      if (state.item.index && idx < state.item.index) {
        state.item.index += 1;
      }
      state.cpq.cart.products.splice(idx, 0, product);
      // localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
    }
  },
  removeCartProduct : (state: StateInterface, indexOrObjRef: number | CpqCartProductLineJson) => {
    const toRemoveIdx = state.cpq.cart.products.findIndex((x, i) => x === indexOrObjRef || i === indexOrObjRef);
    if (state.item.index === toRemoveIdx) {
      state.item = {}
      // localStorage.setItem('currentItem', JSON.stringify(state.item));
    }
    state.cpq.cart.products = state.cpq.cart.products.filter((x, i) => x !== indexOrObjRef && i !== indexOrObjRef);
    // localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  clearCart         : (state: StateInterface) => {
    state.cpq.cart.products = [];
    // localStorage.setItem('state.cpq.cart.products', JSON.stringify(state.cpq.cart.products));
  },
  setFooterContent  : (state: StateInterface, footerContent: any) => {
    state.footerContent = footerContent || {};
  },
  unsetFooterContent: (state: StateInterface) => {
    state.footerContent = {};
  },
  setTotalSteps     : (state: StateInterface, steps: any) => {
    state.stepsContent = {
      ...state.stepsContent,
      totalSteps: steps
    };
  },
  setCurrentStep    : (state: StateInterface, step: any) => {
    state.stepsContent = {
      ...state.stepsContent,
      step
    };
  },
  setCurrentItem    : (state: StateInterface, item: any) => {
    state.item = item;
    // localStorage.setItem('currentItem', JSON.stringify(state.item));
  },
  unsetCurrentItem    : (state: StateInterface) => {
    state.item = {};
    // localStorage.setItem('currentItem', JSON.stringify(state.item));
  },
  setForm    : (state: StateInterface, form: any) => {
    state.form = form;
    // localStorage.setItem('form', JSON.stringify(state.form));
  },
  setPartnerData    : (state: StateInterface, partnerData: any) => {
    state.partnerData = partnerData;
    sessionStorage.setItem('partnerData', JSON.stringify(state.partnerData));
  },
  unsetForm    : (state: StateInterface) => {
    state.form = {};
    localStorage.setItem('form', JSON.stringify(state.form));
  },
  setLang           : (state: StateInterface, lang: string) => {
    state.lang = lang;
    localStorage.setItem('lang', JSON.stringify(state.lang));
  },
  setPaymentType           : (state: StateInterface, paymentType: 1 | 2) => {
    state.paymentType = paymentType;
    localStorage.setItem('paymentType', JSON.stringify(state.paymentType));
  },
};

export const actions = {
  async addProductToCart({ commit }: any, product: CpqCartProductLineJson) {
    await commit('addProductToCart', product);
  },
  async updateCartProducts({ commit }: any, cartProducts: CpqCartProductLineJson[]) {
    await commit('updateCartProducts', cartProducts);
  },
  async updateCartProduct({ commit }: any, data: { idx: number, cartProduct: CpqCartProductLineJson }) {
    await commit('updateCartProduct', data);
  },
  async removeCartProduct({ commit }: any, indexOrObjRef: number | CpqCartProductLineJson) {
    await commit('removeCartProduct', indexOrObjRef);
  },
  async clearCart({ commit }: any) {
    await commit('clearCart');
  },
  async setFooterContent({ commit }: any, footerContent: any) {
    await commit('setFooterContent', footerContent);
  },
  async unsetFooterContent({ commit }: any) {
    await commit('setFooterContent');
  },
  async setTotalSteps({ commit }: any, steps: any) {
    await commit('setTotalSteps', steps);
  },
  async setCurrentStep({ commit }: any, step: any) {
    await commit('setCurrentStep', step);
  },
  async setCurrentItem({ commit }: any, item: any) {
    await commit('setCurrentItem', item);
  },
  async unsetCurrentItem({ commit }: any) {
    await commit('unsetCurrentItem');
  },
  async duplicateCartProduct({ commit }: any, idx: number) {
    await commit('duplicateCartProduct', idx);
  },
  async setForm({ commit }: any, form: any) {
    await commit('setForm', form);
  },
  async unsetForm({ commit }: any) {
    await commit('unsetForm');
  },
  async setPartnerData({ commit }: any, item: any) {
    await commit('setPartnerData', item);
  },
  async setLang({ commit }: any, item: any) {
    await commit('setLang', item);
  },
  async setPaymentType({ commit }: any, paymentType: 1 | 2) {
    await commit('setPaymentType', paymentType);
  },
};

export default createStore({
  getters: {
    getProducts: (state: StateInterface) => state.catalog.products,
    getCartProducts: (state: StateInterface) => state.cpq.cart.products,
    getFooterContent: (state: StateInterface) => state.footerContent,
    getSteps: (state: StateInterface) => state.stepsContent,
    getCurrentItem: (state: StateInterface) => state.item,
    getLang: (state: StateInterface) => state.lang,
    getPartnerData: (state: StateInterface) => state.partnerData,
    getFormData: (state: StateInterface) => state.form,
    getSubmitData: (state: StateInterface) => {
      const contact = state.form.userData ? {
        firstName: state.form.userData.firstName,
        lastName: state.form.userData.lastName,
        email: state.form.userData.email,
        phoneNumber: state.form.userData.phoneNumber,
        address: {
          address1: state.form.userData.address1,
          city: state.form.userData.city,
          countryCode: 'SI', // TODO: If we ever add country input, fill this,
          postalCode: state.form.userData.postalCode,
          primary: true
        }
      } : {};
      const company = state.form.userData ? {
        name: state.form.userData.company,
        vatId: state.form.userData.vatId
      } : {};
      state.cpq.cart.products.map((product) => {
        product.catalogKey = product.key;
        return product;
      })
      const sendData = {
        cpq: {
          ...state.cpq,
          billingAddress: {
            address1: state.form.userData.address1,
            city: state.form.userData.city,
            countryCode: 'SI', // TODO: If we ever add country input, fill this,
            postalCode: state.form.userData.postalCode,
            primary: true
          },
          shippingAddressMatchesBilling: true,
          contact,
          ...(state.form.userData && state.form.userData.business ? {
            company,
          } : {}),
          paymentMethod: state.paymentType === PaymentTypeKeys.immediate ? 'paypal' : 'offer',
          payment: {
            term: state.paymentType === PaymentTypeKeys.immediate ? {
              key: 'af55e03f-fa1a-4949-b109-3c82955f5f12',
              type: 'due-on-receipt'
            } : {
              key: 'd80488d3-c133-49a7-8632-acf8a81ac764',
              type: 'inquiry'
            },
            method: state.paymentType === PaymentTypeKeys.immediate ? {
              type: 'paypal',
            } : undefined
          }
        },
        form: state.form,
        ...(state.partnerKey ? {
          partnerKey: state.partnerKey
        } : {})
      };
      return sendData;
    },
    getIsCartPriceable: (state: StateInterface) => {
      for (const product of state.cpq.cart.products) {
        for (const configurableAddon of (product.configurableAddons || [])) {
          if ((configurableAddon as any).isPriceable === false) {
            return false;
          }
        }
      }
      return true
    }
  },
  state  : {
    catalog: {
      products: []
    },
    cpq    : {
      cart: {
        products: [] // JSON.parse(localStorage.getItem('state.cpq.cart.products') || '[]')
      }
    },
    form: {}, // JSON.parse(localStorage.getItem('form') || '{}'),
    footerContent: {},
    headerContent: {},
    stepsContent: {},
    item: {}, // JSON.parse(localStorage.getItem('currentItem') || '{}'),
    partnerKey: null,
    partnerData: JSON.parse(sessionStorage.getItem('partnerData') || '{}'),
    lang: getLocalOrDefaultLang(),
    loadingEdit: false,
    paymentType: getPaymentTypeOrDefault()
  } as StateInterface,
  mutations,
  actions,
  modules: {},
});
